import { css } from '@emotion/react';
import { Col, Row } from 'antd';
import React from 'react';
import { connect } from 'react-redux';

import Breadcrumbs from '@/src/shared/components/Breadcrumbs';
import SideNav from '@/src/shared/components/SideNav';
import { pciEveryone } from '@/src/shared/constants';
import { bp, colors } from '@/styles';

const mockSideNavItems = [
  {
    path: '/account/update-profile',
    title: 'Update Profile',
  },
  {
    path: '/account/change-password',
    title: 'My Password',
  },
  {
    path: '/account/subscription-preferences',
    title: 'Subscription Preferences',
  },
  {
    path: '/account/contact-lists',
    title: 'My Contact Lists',
  },
  {
    path: '/account/my-committees',
    title: 'My Committees',
  },
];

const mockSideNavAdminItems = [
  {
    path: '/account/update-profile',
    title: 'Update Profile',
  },
  {
    path: '/account/subscription-preferences',
    title: 'Subscription Preferences',
  },
  {
    path: '/account/contact-lists',
    title: 'My Contact Lists',
  },
  {
    path: '/account/my-committees',
    title: 'My Committees',
  },
];

const sideBarMainContent = css`
  background-color: ${colors.white};
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.05);
`;

const sideBar = css`
  display: none;
  @media ${bp.lg} {
    display: block;
  }
`;

function MyAccount({ mainContent, role }) {
  const isAdmin = Array.isArray(role) && role.includes(pciEveryone);

  return (
    <>
      <Breadcrumbs theme="dark" />
      <Row>
        <Col lg={6} css={sideBar}>
          <SideNav pages={isAdmin ? mockSideNavAdminItems : mockSideNavItems} />
        </Col>
        <Col md={24} lg={18} css={sideBarMainContent}>
          {mainContent}
        </Col>
      </Row>
    </>
  );
}

export default connect(
  state => {
    const { auth } = state;
    const { role } = auth;
    return { role };
  },
  null
)(MyAccount);
